import { useState, useRef, useEffect, useMemo } from "react";
import { Tabs } from "@zendeskgarden/react-tabs";
import { Button } from "@zendeskgarden/react-buttons";
import { useSelector } from "redux/store";

import { Alert } from "@zendeskgarden/react-notifications";

import Authorization from "pages/Authorization/Authorization";
import Template from "pages/Template/Template";
import ManageSub from "./ManageSub";

import UserGuide from "pages/UserGuide/UserGuide";
import { checkRole } from "utils/tools";

export default function Welcome() {
  const [tabList, setTabList] = useState([
    { id: 1, name: "Authorize API", tabPanel: <Authorization /> },
    { id: 2, name: "Configure Template", tabPanel: <Template /> },
    // { id: 3, name: "Manage Subscription", tabPanel: <ManageSub /> },
    { id: 4, name: "User Guide", tabPanel: <UserGuide /> },
  ]);
  const role = useSelector((state) => state.user.role);
  const app_user_detail = useSelector((state) => state.user.app_user_auth_detail);
  const [selectedTab, setSelectedTab] = useState("tab-1");
  const [toggleAlert, setToggleAlert] = useState(true);

  const handleTableList = (role) => {
    if (checkRole(role)) {
      setTabList([
        { id: 1, name: "Authorize API", tabPanel: <Authorization /> },
        { id: 2, name: "Configure Template", tabPanel: <Template /> },
        // { id: 3, name: "Manage Subscription", tabPanel: <ManageSub /> },
        { id: 4, name: "User Guide", tabPanel: <UserGuide /> },
      ]);
    } else {
      setTabList([
        { id: 1, name: "Configure Template", tabPanel: <Template /> },
        { id: 2, name: "User Guide", tabPanel: <UserGuide /> },
      ]);
    }
  };
  const changeTab = (e) => {
    setSelectedTab(e);
  };
  useEffect(() => {
    handleTableList(role);
  }, []);

  return (
    <>
      <div className="pt-0 pb-4">
        <div className="content p-7">
          <div className="border-t-1 pt-0 pb-2">
            {/* {!!app_user_detail && !app_user_detail.isAuthorised && (
              <div className="font-medium text-[26px] mb-[10px] text-yellow-700 bg-yellow-100 p-2 rounded text-center">
                API access is currently unavailable. Please authorize access to proceed.
              </div>
            )} */}
            {!!app_user_detail && !!app_user_detail.isAuthorised && !app_user_detail.isSubscribed && (
              <div className="font-medium text-[26px] mb-[10px] text-yellow-700 bg-yellow-100 p-2 rounded text-center">
                Your subscription has ended. Please subscribe to continue using the app.
              </div>
            )}
            <div className="font-medium text-[26px] mb-[10px] zd-text-secondary">Configuration Centre</div>
            <div className="text-[#2F3941] text-[14px]">
              Set up your auto-reply template to reduce SLA times and boost response speed so your agents can serve
              customers faster.
            </div>
            {toggleAlert && !checkRole(role) && (
              <Alert type="info" className="max-w-3xl mt-6">
                Template configuration is managed by your team admin. Please contact them for any changes.
                <Alert.Close aria-label="Close Info Alert" onClick={() => setToggleAlert(!toggleAlert)} />
              </Alert>
            )}
          </div>

          <Tabs selectedItem={selectedTab} onChange={changeTab}>
            <Tabs.TabList>
              {tabList.map((tab) => {
                return <Tabs.Tab item={`tab-${tab.id}`}>{tab.name}</Tabs.Tab>;
              })}
            </Tabs.TabList>

            {/* {tabList.map((tab) => {
              return <Tabs.TabPanel item={`tab-` + tab.id}>{tab.tabPanel}</Tabs.TabPanel>;
            })} */}

            {tabList.map((tab) => {
              const isTab2 = tab.id === 2;
              const forceKey = isTab2 ? `tab2-${selectedTab}` : `tab-${tab.id}`;

              return (
                <Tabs.TabPanel key={`panel-${tab.id}`} item={`tab-${tab.id}`}>
                  <div key={forceKey}>{tab.tabPanel}</div>
                </Tabs.TabPanel>
              );
            })}
          </Tabs>
        </div>

        <div />
      </div>
    </>
  );
}
